import React, { useContext, useEffect, useState } from 'react';
import classnames from 'classnames';
import { AppShortContext } from '../../context/AppContext';
import { useAuth } from '../../context/Auth.context';
import { usePaywallPlans } from '../../hooks/usePaywallPlans.hook';
import { AppSettingsContext } from '../../context/AppSettings.context';
// import { IPlan } from '../../model';
import style from './Paywall.module.scss';
import classNames from 'classnames';
import ModalWithPaywall from '../ModalWithPaywall/ModalWithPaywall';
// import mainContent from '../MainContent';

export type TotalsKeys = 'nfl' | 'mlb' | 'other';

export type TotalsType = Record<TotalsKeys, number>

function PaywallLight() {
  const {subscriptions, loading, baseCheckoutPath} = useAuth();
  const [yearly, setYearly] = useState<boolean>(true);
  const [accessRequested, setAccessRequested] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const {accesses, showBackground, type} = useContext(AppSettingsContext);

  let {
    recommendedPlan,
    bestPlan,
    subscribedPlans,
    currentSubscriptions,
    total,
    allPlans
  } = usePaywallPlans(subscriptions || [], accesses || [], yearly);

  useEffect(() => {
    if (subscribedPlans[0]?.current) {
      setYearly(subscribedPlans[0]?.current?.interval === 'year');
    }
  }, [subscribedPlans]);

  const requestAccess = () => {
    setAccessRequested(true);
    // Here you can implement the logic to request access, e.g., sending a request to the server
    console.log('Requesting access...');
    fetch('https://discord.com/api/webhooks/1379445184575569951/GkVMZWhnI6zxvfR5tT_KbMCAKFaLRPmv31Lt6Q2CDTH1A4Q3TWcQrRreHP1sWU1ffZ6V', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'username': 'FTN Paywall Logger',
        content: `Access requested for Paywall content.
        ${JSON.stringify(accesses, null, 2)}\n
        URL: ${window.location.href}\n
        user: ${window.getCookie?.('access_token')}\n
        @here
        subscriptions: ${JSON.stringify(subscriptions, null, 2)}
        `
      })
    })
  }

  if (loading || !bestPlan) {
    return (
      <div className={classnames(style.loader_wrapper, style.full)}>
        <div className={classnames(style.loader)} style={{margin: '0 auto'}}>
          <span/><span/><span/><span/><span/>
        </div>
      </div>
    );
  }

  const purposePlan = recommendedPlan || bestPlan;
  let sport = purposePlan.display.sport_category;
  if (!['nfl', 'mlb', 'other'].includes(sport)) {
    sport = 'other'
  }

  const currentPrice = total[sport as unknown as TotalsKeys] / 100;
  const planPrice = purposePlan.prices[yearly ? 'yearly' : 'monthly']?.unit_amount / 12 / 100;

  return (
    <AppShortContext.Provider value={{
      baseCheckoutPath,
      yearly,
      currentSubscriptions,
      plans: allPlans
    }}>
      <div className={classnames(style.container, style.main, style.light, {[style.popover]: type === 'popover'})}>
        {recommendedPlan ?
          <>
            {showBackground ? <div className={style.background}>
              Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem
              placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor.
              Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer
              nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra
              inceptos himenaeos.
              Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem
              placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor.
              Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer
              nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra
              inceptos himenaeos.
              Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem
              placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor.
              Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer
              nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra
              inceptos himenaeos.
            </div> : ''}
            <div className={classNames(style.content, style.paywall__light)}>
              <div className={style.paywall__light__title}>
                Content is only available to <span className={style.plan__link}>{purposePlan.display.name}</span> users
                or higher.
              </div>
              {type=== 'popover' ? <div className={style.popover__description}>Upgrade your plan to see this information.</div> : ""}
              <div className={style.buttons}>
                <div className={classNames(style.button, 'button-secondary button-secondary_md')}
                     onClick={() => setShowModal(true)}>
                  View Features
                </div>
                <a
                  className={classnames(style.button, style.button__primary, 'button-primary button-primary_md')}
                  href={`${baseCheckoutPath}?price_id=${purposePlan?.prices?.yearly?.price_id}`}>
                  {currentPrice && planPrice - currentPrice > 0 ? `+${(planPrice - currentPrice).toFixed(2)}$/mo to Upgrade`
                    : `Purchase for ${planPrice.toFixed(2)}$/mo`}
                </a>
              </div>
            </div>
          </> :
          <div className={classnames(style.content, style.accesses__impossible__wrapper)}>
            {accessRequested ? <div className={style.accesses__impossible}>
                Access was requested. We'll keep you posted.</div> :
              <div className={style.accesses__impossible}>
                Do you want to access this content?
                <button
                  className={classnames('button-primary button-primary_md upgrade-button', style.request_access_button)}
                  onClick={requestAccess}>
                  Request Access
                </button>
              </div>}
          </div>
        }
      </div>
      {showModal ? <ModalWithPaywall close={() => setShowModal(false)} accesses={accesses}/> : <></>}
    </AppShortContext.Provider>
  );
}

export default PaywallLight;
